import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
} from "@mui/material";
import Card from "@unisearch/common/ui_element/card";
import Heading from "@unisearch/common/ui_element/heading";
import MentorsCard from "@unisearch/common/ui_element/mentors_card";
import { getAssets } from "@unisearch/helpers";
import API from "@unisearch/helpers/api";
import Image from "next/legacy/image";
import Link from "next/link";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { BsExclamationCircleFill } from "react-icons/bs";
import { CgClose } from "react-icons/cg";
import { MdCheckCircle } from "react-icons/md";
import { Button } from "react-scroll";
import { ReactSVG } from "react-svg";
import styles from "./dashboard.module.scss";

export const StudentDashboard = ({ data }) => {
  const { asPath, query } = useRouter();
  const [countNum, setCountNum] = useState({});
  const [status, setStatus] = useState({});
  const [completion, setCompletion] = useState([]);
  const [info, setInfo] = useState({});
  const [counsellorList, setCounsellorList] = useState([]);
  const [isProfileCompleted, setIsProfileCompleted] = useState(false);

  const [mentorList, setMentorList] = useState([]);
  const [mentorTotal, setMentorTotal] = useState(0);
  const [paginate, setPaginate] = useState({
    currentPage: 1,
    limit: 10000,
    page_total: 0,
    total: 0,
  });
  const [open, setOpen] = useState(true);
  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const fetchCounsellor = async () => {
    await API.get(`/student/status-overview`).then((res) => {
      if (!res.error) {
        setStatus(res.data);
      }
    });
  };

  const fetchStatus = async () => {
    await API.get(`/public/user-counsellor`).then((res) => {
      if (!res.error) {
        setCounsellorList(res.data);
      }
    });
  };

  useEffect(() => {
    fetchCounsellor();
    fetchStatus();
  }, []);
  useEffect(() => {
    let profileCompleted = completion.some((vendor) => vendor["info"] === 0);
    setIsProfileCompleted(!profileCompleted);
  }, [completion]);

  //handle Pagination
  const paginationHandler = (page, value) => {
    setPaginate((prev) => ({ ...prev, currentPage: value }));
  };

  const getMentors = async () => {
    await API.post("/mentor/filter-list-for-student", {
      filter: {},
      sortOrder: "DESC",
      sortField: "id",
      pageNumber: paginate.currentPage,
      pageSize: paginate?.limit,
    }).then((res) => {
      if (!res.error && res.statusCode !== 401) {
        const { limit, page_total, total, results } = res.data;
        setMentorTotal(total);
        setPaginate({
          currentPage: paginate.currentPage,
          limit: limit,
          page_total: page_total,
          total: total,
        });
        setMentorList(results);
      }
    });
  };

  useEffect(() => {
    getMentors();
  }, [paginate.currentPage]);

  let profileComplete = [];

  useEffect(() => {
    // dashboard card
    const getPublicAccess = async () => {
      await API.get("/public/access").then((res) => {
        if (!res.error) {
          setCountNum(res.data);
        }
      });
    };

    // fetch profile completion status
    const getProfileCompletion = async () => {
      await API.get("/student/dashboard/profile-completion").then((res) => {
        if (!res.error && res.statusCode !== 401) {
          const {
            additionalInformation,
            experience,
            lorDetails,
            noOfRecommendedCourse,
            noOfShortlistedCourse,
            personalInformation,
            qualification,
            studyPreferences,
            testScore,
            totalApplication,
          } = res.data;

          setCompletion([
            {
              name: "Personal Information",
              info: personalInformation,
            },
            {
              name: "Study Preferences",
              info: studyPreferences,
            },
            {
              name: "Qualifications",
              info: qualification,
            },
            {
              name: "Work Experience",
              info: experience,
            },
            {
              name: "Test Scores",
              info: testScore,
            },
            {
              name: "Additional Information",
              info: additionalInformation,
            },
          ]);

          setInfo({
            ...info,
            noOfRecommendedCourse,
            noOfShortlistedCourse,
            totalApplication,
          });
        }
      });
    };
    getPublicAccess();
    getProfileCompletion();
  }, []);

  return (
    <>
      <div className={styles.main_wrapper}>
        {asPath === "/app/student" && (
          <>
            <div className={styles.top_section_wrapper}>
              <div className={styles.top_section_left}>
                <div className={styles.short_info_wrapper}>
                  <Grid
                    container
                    spacing={{
                      xs: 1,
                      sm: 2,
                      md: 2,
                      lg: 2,
                      xl: 3,
                    }}
                  >
                    <Grid item xs={12} sm={6} md={4}>
                      <Link legacyBehavior href="/explore-university">
                        <a target="_blank">
                          <div className={styles.short_info}>
                            <div className={styles.number_icon}>
                              <div className={styles.info_num}>
                                {countNum?.country}
                              </div>
                              <ReactSVG
                                src={getAssets(
                                  "assets/images/admin/student/flag.svg"
                                )}
                              />
                            </div>
                            <div
                              className={`${styles.info_name} ${styles.country_name}`}
                            >
                              Countries
                            </div>
                          </div>
                        </a>
                      </Link>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      <Link legacyBehavior href="/explore-university">
                        <a target="_blank">
                          <div className={styles.short_info}>
                            <div className={styles.number_icon}>
                              <div className={styles.info_num}>
                                {countNum?.university}
                              </div>
                              <ReactSVG
                                src={getAssets(
                                  "assets/images/admin/student/university.svg"
                                )}
                              />
                            </div>
                            <div
                              className={`${styles.info_name} ${styles.uni_name}`}
                            >
                              Universities
                            </div>
                          </div>
                        </a>
                      </Link>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      <Link
                        legacyBehavior
                        href="/search?ref=general&limit=10&page=1"
                      >
                        <a target="_blank">
                          <div className={styles.short_info}>
                            <div className={styles.number_icon}>
                              <div className={styles.info_num}>
                                {countNum?.course}
                              </div>
                              <ReactSVG
                                src={getAssets(
                                  "assets/images/admin/student/school_hat.svg"
                                )}
                              />
                            </div>
                            <div
                              className={`${styles.info_name} ${styles.uni_course}`}
                            >
                              Courses
                            </div>
                          </div>
                        </a>
                      </Link>
                    </Grid>
                  </Grid>
                </div>

                <Card className={styles.profile_conpilation}>
                  <Heading
                    heading="Profile Completion"
                    label={
                      isProfileCompleted
                        ? "Your profile is completed."
                        : "Your profile is incomplete. Please complete your profile for more filtered recommendations."
                    }
                  />
                  <div className={styles.list_wrapper}>
                    <Grid
                      container
                      rowSpacing={{
                        xs: 1,
                        sm: 2,
                        md: 2,
                        lg: 2,
                        xl: 2,
                      }}
                      columnSpacing={{
                        xs: 1,
                        sm: 2,
                        md: 2,
                        lg: 2,
                        xl: 2,
                      }}
                    >
                      {completion.map((item, i) => (
                        <Grid item xs={12} sm={6} md={4} key={`completion${i}`}>
                          <div className={styles.activity_list}>
                            <span>{item.name}</span>
                            {item.info > 0 ? (
                              <MdCheckCircle
                                style={{
                                  color: "#1BC5BD",
                                  fontSize: "20px",
                                  minWidth: "max-content",
                                }}
                              />
                            ) : (
                              <BsExclamationCircleFill
                                style={{
                                  color: "#FFD43F",
                                  fontSize: "20px",
                                  minWidth: "max-content",
                                }}
                              />
                            )}
                          </div>
                        </Grid>
                      ))}
                    </Grid>
                  </div>
                </Card>

                {/* info_uni_wrapper */}
                <div className={styles.info_uni_wrapper}>
                  <div className={styles.info_uni_card}>
                    <ReactSVG
                      className={styles.info_uni_card_icon}
                      src={getAssets(
                        "assets/icons/admin/student/profile_evaluation_report.svg"
                      )}
                    />
                    <div className={styles.info_uni_card_title}>
                      Profile Evaluation Report
                    </div>

                    <Link legacyBehavior href="/app/student/report">
                      <a className={styles.info_uni_card_desc}>
                        {status?.totalRecommendedCourse} Courses Recommendations
                        for you
                      </a>
                    </Link>
                  </div>
                  <div className={styles.info_uni_card}>
                    <ReactSVG
                      className={styles.info_uni_card_icon}
                      src={getAssets(
                        "assets/icons/admin/student/shortlist_university.svg"
                      )}
                    />
                    <div className={styles.info_uni_card_title}>
                      Shortlisted University
                    </div>
                    <Link legacyBehavior href="/app/student/report/university">
                      <a className={styles.info_uni_card_desc}>
                        {status?.shortListedUniversity} Shortlisted University
                      </a>
                    </Link>
                  </div>
                  <div className={styles.info_uni_card}>
                    <ReactSVG
                      className={styles.info_uni_card_icon}
                      src={getAssets(
                        "assets/icons/admin/student/total_application.svg"
                      )}
                    />
                    <div className={styles.info_uni_card_title}>
                      Total Application
                    </div>
                    <Link legacyBehavior href="/app/student/application">
                      <a className={styles.info_uni_card_desc}>
                        {status?.totalApplication} Applications
                      </a>
                    </Link>
                  </div>
                </div>
              </div>

              {/* recommended_counsellor */}
              {counsellorList?.length > 0 && (
                <div className={styles.recommended_counsellor_wrapper}>
                  <h4 className={styles.recommended_counsellor_heading}>
                    Still Confused About your Study Abroad Needs?
                  </h4>
                  <div className={styles.recommended_counsellor_sub}>
                    Connect with your UniSearch Expert now and get personalized
                    plans suited for you.
                  </div>

                  <div className={styles.recommended_counsellor_lists}>
                    {counsellorList?.map((item, i) => {
                      return (
                        <Link
                          legacyBehavior
                          href={`/app/student/counsellor/${item?.id}`}
                          key={`counsellor${i}`}
                        >
                          <a>
                            <div
                              className={styles.recommended_counsellor}
                              key={i}
                            >
                              <div
                                className={styles.recommended_counsellor_image}
                              >
                                <img
                                  src={
                                    item?.profileImageSrc
                                      ? item?.profileImageSrc
                                      : getAssets(
                                          "assets/counsellor-avatar-small.png"
                                        )
                                  }
                                  alt={`${item?.firstName}`}
                                />
                              </div>
                              <div
                                className={styles.recommended_counsellor_detail}
                              >
                                <div>
                                  <div
                                    className={
                                      styles.recommended_counsellor_name
                                    }
                                  >
                                    {item?.firstName} {item?.lastName}
                                  </div>
                                  <div
                                    className={
                                      styles.recommended_counsellor_designation
                                    }
                                  >
                                    Counsellor
                                  </div>
                                </div>
                                {/* <BiDotsVerticalRounded style={{ fontSize: "20px" }} /> */}
                              </div>
                            </div>
                          </a>
                        </Link>
                      );
                    })}
                  </div>
                </div>
              )}
            </div>

            {/* recommended mentor */}
            {/* {mentorTotal > 0 && (
              <div className={styles.recommended_mentor_wrapper}>
                <h4 className={styles.recommended_mentor_heading}>
                  Recommended mentors based on your profile ({mentorTotal})
                </h4>

                <div className={styles.recommended_mentor_list}>
                  {mentorList?.map((item, i) => (
                    <MentorsCard type="mentor" key={i} item={item} />
                  ))}
                </div>
              </div>
            )} */}
          </>
        )}

        {asPath === "/app/student/elearning" && (
          <>
            <div className={styles.course_count_wrapper}>
              <Grid
                container
                spacing={{
                  xs: 1,
                  sm: 2,
                  md: 2,
                  lg: 2,
                  xl: 4,
                }}
              >
                <Grid item xs={12} sm={6} md={3}>
                  <div className={styles.count_course_card}>
                    <ReactSVG
                      src={getAssets(
                        "assets/images/admin/student/enrolled-course.svg"
                      )}
                    />
                    <div>
                      <div className={styles.count_course_card_num}>1</div>
                      <div className={styles.count_course_card_text}>
                        Enrolled Course
                      </div>
                    </div>
                  </div>
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <div className={styles.count_course_card}>
                    <ReactSVG
                      src={getAssets(
                        "assets/images/admin/student/active-course.svg"
                      )}
                    />
                    <div>
                      <div className={styles.count_course_card_num}>0</div>
                      <div className={styles.count_course_card_text}>
                        Active Course
                      </div>
                    </div>
                  </div>
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <div className={styles.count_course_card}>
                    <ReactSVG
                      src={getAssets(
                        "assets/images/admin/student/complete-course.svg"
                      )}
                    />
                    <div>
                      <div className={styles.count_course_card_num}>0</div>
                      <div className={styles.count_course_card_text}>
                        Completed Course
                      </div>
                    </div>
                  </div>
                </Grid>
              </Grid>
            </div>
          </>
        )}
      </div>
      {/* <Dialog
        maxWidth="md"
        open={open}
        onClose={handleClose}
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
        sx={{
          "& .MuiDialog-container": {
            "& .MuiPaper-root": {
              width: "100%",
              maxWidth: "834px", // Set your width here
            },
          },
        }}
      >
        <DialogTitle
          sx={{
            m: 0,
            p: 2,
            fontSize: "13px",
            fontWeight: 700,
            color: "#0F1041",
          }}
        >
          Complete Your Profile
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,

              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CgClose />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ borderBottom: 0 }} dividers>
          <div sx={{ p: 4 }}>
            <div className={styles.evolation_image_wrapper}>
              <Image
                layout="responsive"
                width={340}
                height={192}
                blurDataURL={getAssets(
                  "assets/images/study/country_placeholder.webp"
                )}
                placeholder="blur"
                src={getAssets(
                  "/assets/images/admin/student/dashboard-profile-evolation.webp"
                )}
                alt="Intro video feature"
              />
            </div>
            <div className={styles.content_body}>
              <h4 className={styles.title}>Plese Complete Your Profile</h4>
              <p className={styles.description}>
                Universities prefer to look at profiles that are complete. A
                complete profile helps us make accurate university
                recommendations and give you.
              </p>
            </div>
          </div>
        </DialogContent>
        <DialogActions sx={{ paddingBottom: "30px" }}>
          <Link  legacyBehavior   href="/profile/evaluation">
            <a className={styles.footer_btn}>Let’s Do It</a>
          </Link>
        </DialogActions>
      </Dialog> */}
    </>
  );
};

export default StudentDashboard;
